"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParamArray = void 0;
/*
 * Helper to get the values of a query parameter from the URL
 */
const getParamArray = (param, separator = ',') => {
    var _a;
    const location = new URL(window.location.href);
    return ((_a = location.searchParams.get(param)) === null || _a === void 0 ? void 0 : _a.split(separator)) || [];
};
exports.getParamArray = getParamArray;
//# sourceMappingURL=url-params.util.js.map